import React, { forwardRef, useRef, useCallback } from 'react';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { english } from "flatpickr/dist/l10n/default.js";

const DatePicker = forwardRef(({
                                   value,
                                   onChange,
                                   placeholder = "Select day...",
                                   enableTime = false,
                                   dateFormat = "Y-m-d",
                                   mode = "single",
                                   options = {},
                                   className = "",
                                   disabled = false
                               }, ref) => {

    // Store latest picked dates in a ref so we don't re-render while the popup is open
    const pendingDates = useRef(null);

    const handleChange = useCallback((dates) => {
        if (enableTime) {
            // Just stash the value; we'll commit it onClose
            pendingDates.current = dates;
        } else {
            onChange?.(dates);
        }
    }, [enableTime, onChange]);

    const handleClose = useCallback((dates) => {
        if (enableTime && pendingDates.current) {
            onChange?.(pendingDates.current);
            pendingDates.current = null;
        }
    }, [enableTime, onChange]);

    const defaultOptions = {
        enableTime,
        dateFormat,
        mode,
        locale: english,
        position: "auto",
        appendTo: typeof document !== 'undefined' ? document.body : undefined,
        disableMobile: true,
        ...(enableTime ? { closeOnSelect: false } : {}),
        ...options,
        onClose: handleClose
    };

    return (
        <div className="flatpickr-input-container">
            <Flatpickr
                ref={ref}
                value={value}
                onChange={handleChange}
                options={defaultOptions}
                placeholder={placeholder}
                className={`form-control ${className}`}
                style={{ paddingLeft: '2.25rem' }}
                disabled={disabled}
            />
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"
                 className="flatpickr-icon text-body-tertiary" style={{ marginTop: "3px" }}>
                <path d="M12,19a1,1,0,1,0-1-1A1,1,0,0,0,12,19Zm5,0a1,1,0,1,0-1-1A1,1,0,0,0,17,19Zm0-4a1,1,0,1,0-1-1A1,1,0,0,0,17,15Zm-5,0a1,1,0,1,0-1-1A1,1,0,0,0,12,15ZM19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,0,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V11H20ZM20,9H4V6A1,1,0,0,1,5,5H6V6A1,1,0,0,0,8,6V5h8V6a1,1,0,0,0,2,0V5h1a1,1,0,0,1,1,1ZM7,15a1,1,0,1,0-1-1A1,1,0,0,0,7,15Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,7,19Z"></path>
            </svg>
        </div>
    );
});

export default DatePicker;
